import OrientedImage from 'image-autorotate'

export class Picture {
  public url: string

  fromUrl (url) {
    this.url = url
    return this
  }

  async fromInputData (file): Promise<Picture> {
    const reader = new OrientedImage(file)

    const { url } = await reader.getFile()
      .catch(() => reader.getOriginalFile())
    this.url = url

    return this
  }

  asGalleryObject (): Promise<Object> {
    return new Promise((resolve, reject) => {
      const img = new Image()

      img.onload = function () {
        const newImg = this as any
        resolve({
          src: newImg.src,
          w: newImg.width,
          h: newImg.height
        })
      }

      img.src = this.url
    })
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/models/picture.model.ts